export function isDischargeReason(reason = "") {
  return /Discharged /.test(reason);
}
export function isDropReason(reason = "") {
  return /Dropped /.test(reason);
}
